import { apiFetch } from "./client";

export interface OnboardStartResponse {
  consentUrl: string;
  stateToken: string;
}

export interface OnboardUser {
  id: string;
  displayName: string;
  email: string;
  userPrincipalName: string;
}

export interface OnboardResult {
  success: boolean;
  tenantId: string;
  tenantName: string;
  users: OnboardUser[];
  companyId?: string;
}

export const tenantOnboardApi = {
  startOnboard: (companyId?: string) =>
    apiFetch<OnboardStartResponse>("/tenant-onboard/start", {
      method: "POST",
      body: JSON.stringify({ companyId }),
    }),

  getResult: (stateToken: string) =>
    apiFetch<OnboardResult>(`/tenant-onboard/result/${stateToken}`),
};
